import React from 'react';
import UserContext from './context';

const useUser = () => {
	const user = React.useContext(UserContext);
	return user;
};

export default useUser;
